import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-triArrow",
  "use": "icon-triArrow-usage",
  "viewBox": "0 0 11 13",
  "content": "<symbol viewBox=\"0 0 11 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-triArrow\">\r\n<path d=\"M9.59733 6.25095C10.0466 6.54738 10.0466 7.20653 9.59733 7.50296L1.91306 12.5733C1.41441 12.9023 0.75 12.5447 0.75 11.9473L0.75 1.80665C0.75 1.20924 1.41441 0.851624 1.91306 1.18064L9.59733 6.25095Z\" stroke=\"currentColor\" stroke-width=\"0.5\" stroke-linecap=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol